import React from 'react'
import { SettingsRow } from "pages/NewSettings/settings-row";
import useTranslation from "hooks/useTranslation";
import { Fields } from "uicomponents";
import { get } from "lodash";
import { ExternalLink } from "lucide-react";
import { Typography } from "antd";
import { Field } from "formik";

const ChequeSettings = ({ values, setFieldValue }) => {
  const { tr } = useTranslation();
  return (
    <div>
      <div>
        {/* <SettingsRow
          title={tr("Показать QR-code в чеке")}
          description={tr(
            "Отображать QR-код в чеке кассира"
          )}
        >
          <Field
            component={Fields.CheckboxS1}
            name="qr_show"
            checked={values.qr_show}
            position={"left"}
          //
          />
        </SettingsRow> */}

        {/* <SettingsRow
          title={tr("Объединить заказ")}
          description={tr(
            "Разрешить кассиру объединять заказы"
          )}
        >
          <Field
            component={Fields.CheckboxS1}
            name="order_unite"
            checked={values.order_unite}
            position={"left"}
          />
        </SettingsRow> */}

        {/* <SettingsRow
          title={tr("Объединить продукт")}
          description={tr(
            "При включении одинаковые продукт в заказе будут автоматически объединяться"
          )}
        >
          <Field
            component={Fields.CheckboxS1}
            name="order_good_unite"
            checked={values.order_good_unite}
            position={"left"}
          />
        </SettingsRow> */}

        {/* <SettingsRow
          title={tr("QR code")}
          description={tr("")}
        >
          <Typography.Link
            href={values.qrcode}
            target="_blank"
            className="flex items-center gap-3"
          >
            {values.qrcode} <ExternalLink size={20} />
          </Typography.Link>
        </SettingsRow> */}

        <SettingsRow
          title={tr("Чек (общий счет)")}
          description={tr(
            "Выберите язык печати общего чека для клиента"
          )}
        >
          <Field
            component={Fields.SelectS1}
            name={"check_language"}
            placeholder={tr("Выберите")}
            optionValue={"value"}
            optionLabel={"label"}
            options={[
              { label: tr("O'z"), value: "uz" },
              { label: tr("Ру"), value: "ru" },
              { label: tr("En"), value: "en" },
              { label: tr("zh"), value: "zh" }
            ]}
          />
        </SettingsRow>

        {/* <SettingsRow
          title={tr("Чек (другого сотрудника)")}
          description={tr(
            "Выберите язык печати чека для кухни (другого сотрудника)"
          )}
        >
          <Field
            component={Fields.SelectS1}
            name={"check_language_for_kitchener"}
            placeholder={tr("Выберите")}
            optionValue={"value"}
            optionLabel={"label"}
            options={[
              { label: tr("O'z"), value: "uz" },
              { label: tr("Ру"), value: "ru" },
              { label: tr("En"), value: "en" },
              { label: tr("zh"), value: "zh" }
            ]}
          />
        </SettingsRow> */}

        {/* <SettingsRow
          title={tr("Размер чекдругого сотрудника")}
          description={tr(
            "Выберите размер текста чека для кухни (другого сотрудника)"
          )}
        >
          <Field
            component={Fields.SelectS1}
            name={"kitchener_check_size"}
            placeholder={tr("Стандартный")}
            optionValue={"value"}
            optionLabel={"label"}
            options={[
              {
                value: "0",
                label: <div>{tr("Стандартный")}</div>
              },
              {
                value: 5,
                label: (
                  <div className="!text-lg">
                    {tr("Крупный")}
                  </div>
                )
              },
              {
                value: 1,
                label: (
                  <div className="text-2xl">{"1X"}</div>
                )
              },
              {
                value: 2,
                label: (
                  <div className="text-3xl">{"2X"}</div>
                )
              }
            ]}
          />
        </SettingsRow> */}
      </div>
    </div>
  )
}

export default ChequeSettings